import { Capacitor, registerPlugin } from '@capacitor/core';

const NativeGoogleSignIn = registerPlugin('NativeGoogleSignIn');

export function isAndroidNativeGoogle() {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android';
}

export async function signInWithGoogleNative() {
  if (!isAndroidNativeGoogle()) {
    throw Object.assign(new Error('Native Google Sign-In is available only on Android.'), { code: 'GOOGLE_NATIVE_WRONG_PLATFORM' });
  }
  console.info('[9jaWin GoogleAuth] platform=android method=native plugin=NativeGoogleSignIn');
  if (!NativeGoogleSignIn || typeof NativeGoogleSignIn.signIn !== 'function') {
    console.error('[9jaWin GoogleAuth] native plugin unavailable');
    throw Object.assign(new Error('Native Google Sign-In is unavailable in this Android build.'), { code: 'GOOGLE_PLUGIN_UNAVAILABLE' });
  }
  try {
    const result = await NativeGoogleSignIn.signIn();
    if (!result?.idToken) {
      console.error('[9jaWin GoogleAuth] native result missing idToken');
      throw Object.assign(new Error('Google did not return an ID token.'), { code: 'GOOGLE_TOKEN_MISSING' });
    }
    console.info('[9jaWin GoogleAuth] native result=success');
    return result.idToken;
  } catch (error) {
    console.error('[9jaWin GoogleAuth] native result=failure code=%s', error?.code || 'UNKNOWN');
    throw error;
  }
}
